import { ThemeMode } from 'core/theme/contexts';

export enum ContentType {
  LOGO = 'logo',
}

export type Appearance = {
  themeMode: ThemeMode;
  screensConfig: {
    header?: {
      exclude: string[];
      contentTypes: Record<ContentType, string[]>;
    };
    progressBar: {
      title?: string;
      amountOfSteps: number;
    }[];
  };
};
